import React from 'react';
import PropTypes from 'prop-types';
import { Row, Button } from 'reactstrap';
/* Components */
import { Link } from 'site-modules/shared/components/link/link';
/* Utils */
import { getStaticImageUrl } from 'client/utils/image-helpers';
/* Constants */
import { CAPITAL_ONE_LOGO_SRC } from 'client/site-modules/financing/constants/financing';

import './abandon-screen.scss';

export function AbandonScreen({ onStayClick, url = '' }) {
  return (
    <>
      <Row className="pre-qualified-form mx-auto my-0">
        <img
          className="d-block mx-auto mt-2 mb-1_5"
          width={111}
          height={40}
          src={getStaticImageUrl(CAPITAL_ONE_LOGO_SRC)}
          alt="capital1"
        />
      </Row>
      <Row className="fw-bold size-20 px-1 justify-content-center">
        <div>Leave without saving?</div>
      </Row>
      <Row className="mt-0_5 justify-content-center">
        <div>Your progress will not be saved.</div>
      </Row>
      <Row className="justify-content-center">
        <Button tag={Link} to={url} className="px-1 mt-1_5 mb-0_75 leave-btn" color="primary-b" rel="nofollow" block>
          Yes, leave
        </Button>
      </Row>
      <Row className="justify-content-center">
        <Button className="ms-0_25 link-button stay-btn btn-bg-white text-primary border-0" onClick={onStayClick}>
          Stay and continue
        </Button>
      </Row>
    </>
  );
}

AbandonScreen.propTypes = {
  onStayClick: PropTypes.func.isRequired,
  url: PropTypes.string,
};
